// 環境チェック用のユーティリティ関数

/**
 * 開発環境かどうかを判定
 */
export const isDev = (): boolean => {
  return process.env.NODE_ENV === 'development';
};

/**
 * プロダクション環境かどうかを判定
 */
export const isProd = (): boolean => {
  return process.env.NODE_ENV === 'production';
};

/**
 * テスト環境かどうかを判定
 */
export const isTest = (): boolean => {
  return process.env.NODE_ENV === 'test';
};

/**
 * 現在の環境名を取得
 */
export const getEnvironment = (): string => {
  return process.env.NODE_ENV || 'development';
};